import React from 'react';

const Step6Shared = () => (
  <div>
    <ol>
      <li>
         Travel Agent or Travel Provider (airline, hotel, cruise liner, tour company etc.) cancellation, delay and /or amendment confirmation including details of refunds, cancellations fees, credits or compensation offered.
        <ul>
          <li>Contact your travel provider first and ask for a refund. If they decline or partially pay the claim, ask for a confirmation of refund and supply this.</li>
        </ul>
      </li>
      <li>
        Where applicable, documentation outlining the reason for cancellation:
        <ul
          style={{
            listStyleType: 'lower-alpha',
          }}
        >
          <li>Completed Medical Certificate and Medical Authority forms relating to the ill or injured person;</li>
          <li>Death certificate which states the cause of death; or</li>
          <li>Any other relevant documentation supporting the reason for trip cancellation.</li>
        </ul>
      </li>
      <li>
        Original flight schedule and/or itinerary (with terms and conditions).
      </li>
      <li>Copy of your amended itinerary or booking details.</li>
      <li>Tax invoices, receipts and/or proof of payment for each expense you are claiming e.g. travel and accommodation arrangements.</li>
      <li>Confirmation of special event if claiming for alternative transport expenses.</li>
    </ol>
  </div>
  );

export default Step6Shared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step6/components/Step6Shared.js